import { Card, CardBody, Col, Container } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { Cart, ECommerce } from "../../../Constant";
import { CartData } from "./CartData";

const CartContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Cart} parent={ECommerce} title={Cart} />
      <Container fluid>
        <Col sm="12">
          <Card>
            <CommonCardHeader title={Cart} />
            <CardBody>
              <CartData />
            </CardBody>
          </Card>
        </Col>
      </Container>
    </>
  );
};

export default CartContainer;
